import React, {Component, useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    List,
    Card,
    Avatar,
    Popover,
    Select, Divider,
    Popconfirm, Table, Tag, Modal, Form, Switch
} from 'antd';
import {EditOutlined, DeleteOutlined, WechatOutlined} from '@ant-design/icons';
import 'moment/locale/zh-cn';
import moment from "moment";
import Backgroung from '../img/seal.png';
import * as url from "url";


const Load = (that) => {

    fetch("https://pd.pokemonbye.com:8084/api/getprint?time=" + that.state.outtime)
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                if (array != null && array.length > 0) {
                    that.setState({
                        print: "打印中"
                    });
                    //打印重复可在此判断
                }
                var list = {};
                list.name = that.state.name;
                list.address = that.state.address;
                list.buyer = that.state.buyer;
                list.id = that.state.id;
                list.stock = that.state.stock;
                list.value = that.state.value;
                list.car = that.state.car;
                list.intime = that.state.intime;
                list.outtime = that.state.outtime;
                list.num = that.state.num;
                list.time = that.state.time;
                list.weight1 = that.state.weight1;
                list.weight2 = that.state.weight2;
                function queryParse(query){
                    let queryText = "";
                    for(let key in query){
                        queryText += `${key}=${query[key]}&`;
                    }
                    return queryText.slice(0,-1);
                }

                fetch("https://pd.pokemonbye.com:8081/api/printhome",
                    {
                        method:'post',
                        body:queryParse(list),
                        headers:{
                            'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
                        }
                    })
                    .then(res => res.json())
                    .then(
                        (result) => {
                            that.setState({
                                print: "打印完成"
                            });

                            fetch("https://pd.pokemonbye.com:8084/api/insertprint?time=" + that.state.outtime)
                                .then(res => res.json())
                                .then(
                                    (result) => {
                                    },
                                    // 注意：需要在此处处理错误
                                    // 而不是使用 catch() 去捕获错误
                                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                                    (error) => {
                                        that.setState({
                                            isLoaded: true,
                                            error
                                        });
                                    }
                                )
                        },
                        // 注意：需要在此处处理错误
                        // 而不是使用 catch() 去捕获错误
                        // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                        (error) => {
                            that.setState({
                                isLoaded: true,
                                error
                            });
                        }
                    )
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: true,
                    error
                });
            }
        )
}

const Load2 = (that) => {

    fetch("https://pd.pokemonbye.com:8084/api/getprint?time=" + that.state.outtime)
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                if (array != null && array.length > 0) {
                    that.setState({
                        print: "您已经超过打印次数上限"
                    });
                    //打印重复可在此判断
                }else{
                    var list = {};
                    list.name = that.state.name;
                    list.address = that.state.address;
                    list.buyer = that.state.buyer;
                    list.id = that.state.id;
                    list.stock = that.state.stock;
                    list.value = that.state.value;
                    list.car = that.state.car;
                    list.intime = that.state.intime;
                    list.outtime = that.state.outtime;
                    list.num = that.state.num;
                    list.time = that.state.time;
                    list.weight1 = that.state.weight1;
                    list.weight2 = that.state.weight2;
                    function queryParse(query){
                        let queryText = "";
                        for(let key in query){
                            queryText += `${key}=${query[key]}&`;
                        }
                        return queryText.slice(0,-1);
                    }

                    fetch("https://pd.pokemonbye.com:8081/api/printtruck",
                        {
                            method:'post',
                            body:queryParse(list),
                            headers:{
                                'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
                            }
                        })
                        .then(res => res.json())
                        .then(
                            (result) => {
                                that.setState({
                                    print: "打印完成"
                                });

                                fetch("https://pd.pokemonbye.com:8084/api/insertprint?time=" + that.state.outtime)
                                    .then(res => res.json())
                                    .then(
                                        (result) => {
                                        },
                                        // 注意：需要在此处处理错误
                                        // 而不是使用 catch() 去捕获错误
                                        // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                                        (error) => {
                                            that.setState({
                                                isLoaded: true,
                                                error
                                            });
                                        }
                                    )
                            },
                            // 注意：需要在此处处理错误
                            // 而不是使用 catch() 去捕获错误
                            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                            (error) => {
                                that.setState({
                                    isLoaded: true,
                                    error
                                });
                            }
                        )
                }
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: true,
                    error
                });
            }
        )
}

const Load3 = (that) => {

    fetch("https://pd.pokemonbye.com:8084/api/getprint?time=" + that.state.outtime)
        .then(res => res.json())
        .then(
            (result) => {
                let array = result.data;
                if (array != null && array.length > 0) {
                    that.setState({
                        print: "打印中"
                    });
                    //打印重复可在此判断
                }
                var list = {};
                list.name = that.state.name;
                list.address = that.state.address;
                list.buyer = that.state.buyer;
                list.id = that.state.id;
                list.stock = that.state.stock;
                list.value = that.state.value;
                list.car = that.state.car;
                list.intime = that.state.intime;
                list.outtime = that.state.outtime;
                list.num = that.state.num;
                list.time = that.state.time;
                list.weight1 = that.state.weight1;
                list.weight2 = that.state.weight2;
                function queryParse(query){
                    let queryText = "";
                    for(let key in query){
                        queryText += `${key}=${query[key]}&`;
                    }
                    return queryText.slice(0,-1);
                }

                fetch("https://pd.pokemonbye.com:8081/api/printtruck",
                    {
                        method:'post',
                        body:queryParse(list),
                        headers:{
                            'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
                        }
                    })
                    .then(res => res.json())
                    .then(
                        (result) => {
                            that.setState({
                                print: "打印完成"
                            });

                            fetch("https://pd.pokemonbye.com:8084/api/insertprint?time=" + that.state.outtime)
                                .then(res => res.json())
                                .then(
                                    (result) => {
                                    },
                                    // 注意：需要在此处处理错误
                                    // 而不是使用 catch() 去捕获错误
                                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                                    (error) => {
                                        that.setState({
                                            isLoaded: true,
                                            error
                                        });
                                    }
                                )
                        },
                        // 注意：需要在此处处理错误
                        // 而不是使用 catch() 去捕获错误
                        // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                        (error) => {
                            that.setState({
                                isLoaded: true,
                                error
                            });
                        }
                    )
            },
            // 注意：需要在此处处理错误
            // 而不是使用 catch() 去捕获错误
            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
            (error) => {
                that.setState({
                    isLoaded: true,
                    error
                });
            }
        )
}

class PagePurTicketPrint extends Component {


    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const type = params.get("type");
        const name = params.get("name");
        const address = params.get("address");
        const buyer = params.get("buyer");
        const id = params.get("id");
        const stock = params.get("stock");
        const value = params.get("value");
        const car = params.get("car");
        const intime = params.get("intime");
        const outtime = params.get("outtime");
        const num = params.get("num");
        const time = params.get("time");
        const weight1 = params.get("weight1");
        const weight2 = params.get("weight2");
        this.state = {
            title: "打印",
            type: type,
            name: name,
            address: address,
            buyer: buyer,
            id: id,
            stock: stock,
            value: value,
            car: car,
            intime: intime,
            outtime: outtime,
            num: num,
            time: time,
            weight1: weight1,
            weight2: weight2,
            print: "打印中"
        };
    }

    componentDidMount() {
        if(this.state.type==1){
            Load(this)
        }else if(this.state.type==2){
            Load3(this)
        }
    }

    render() {
        return (
            <div>

                <PageHeader
                    ghost={false}
                    style={{
                        backgroundColor: '#00000000'
                    }}
                >
                    {this.state.print}
                </PageHeader>
            </div>
        );
    }
}

export default PagePurTicketPrint;


